/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Segment, Dimmer, Loader } from 'semantic-ui-react';
import { useToasts } from 'react-toast-notifications';
import { selectCurrentUserApiToken } from '../slices/currentUser/currentUserSlice';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';
import loadInvite from '../functions/loadInviteAPI';
import acceptInvite from '../functions/acceptInviteAPI';

const acceptInviteFromPage = async (apiToken, inviteCode, invitePageState, setInvitePageState, navigate, addToast) => {
    let response = await acceptInvite(apiToken, inviteCode);
    if (response?.success) {
        if (inviteCode && inviteCode.substring(0,4) === "mult") {
            addToast('You are now an editor to these resources', { appearance: 'success' });
        } else {
            navigate("/"+invitePageState.resourceId, { replace: true });
            addToast('You are now an editor to this resource', { appearance: 'success' });
        }
        setInvitePageState(prevState => { return { ...prevState, 'acceptedInvite': true }; }); //Probably not needed
    }
}

const loadInviteToPage = async (apiToken, inviteCode, setInvitePageState) => {

    let response = await loadInvite(apiToken, inviteCode);
    if (response?.success) {
        setInvitePageState({
            'loaded': true, 'loading': false,
            'inviter': response.inviter,
            'resourceId': response.resourceId,
            'resourceIds': response.resourceIds,
            'resourceTitle': response.resourceTitle,
            'label': response.label,
            'alreadyJoined': response.alreadyjoined
        });
    } else {
        setInvitePageState({ 'loading': false });
    }
}

// eslint-disable-next-line no-empty-pattern
const InvitedToResourcePage = ({ }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const { inviteCode } = useParams();
    const navigate = useNavigate();
    const { addToast } = useToasts();

    const [invitePageState, setInvitePageState] = useState({ 'loading': true, 'loaded': false });

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Resource Invite"));
    }, []);

    useEffect(() => {
        if (apiToken && inviteCode) {
            loadInviteToPage(apiToken, inviteCode, setInvitePageState);
        }
    }, [apiToken]);

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            {apiToken ?
                <>
                    {invitePageState.loading &&
                        <Dimmer className={"loadingDimmer"} active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>}
                    {invitePageState.loaded ?
                        <>
                            {invitePageState.acceptedInvite ?
                                <>
                                    <h2>You are now an editor for {invitePageState.resourceId ?
                                        <a href={"/" + invitePageState.resourceId} target="_blank" rel="noopener noreferrer">{invitePageState.resourceTitle} ({invitePageState.resourceId})</a>
                                        :
                                        <>{invitePageState.label} {invitePageState.resourceIds?.join(', ')}</>
                                    }
                                    </h2>
                                </>
                                :
                                <>

                                    <h2 style={{ textAlign: "center", color: "#AC3B61" }}>
                                        You've been invited by {invitePageState.inviter} to become an editor for {invitePageState.resourceTitle ?
                                            <>resource: {invitePageState.resourceTitle} (<a href={"/" + invitePageState.resourceId} target="_blank" rel="noopener noreferrer">{invitePageState.resourceId}</a>)</>
                                            :
                                            <>{invitePageState.label} {invitePageState.resourceIds?.join(', ')}</>
                                        }
                                    </h2>
                                    <br /><br />
                                    {invitePageState.alreadyJoined ?
                                        <h2>You are already an editor for this resource.</h2>
                                        :
                                        <Button className="formButton positive"
                                            content={`Join as an Editor for ${invitePageState.label ? invitePageState.label : 'the Resource'}`} compact
                                            onClick={() => {
                                                /* TODO - CREATE SERVER SIDE FUNCTION TO BE ADDED TO PERMISSION GROUP, pass the invite code to the function*/
                                                acceptInviteFromPage(apiToken, inviteCode, invitePageState, setInvitePageState, navigate, addToast);
                                            }} />
                                    }
                                </>
                            }
                        </>
                        :
                        <>{!invitePageState.loading &&
                            <h2>No invite has been found with that code. Perhaps the invite link was revoked.</h2>}</>
                    }
                </>
                :
                <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
            }
        </Segment>
    </div>
};

export default InvitedToResourcePage;